import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { forkJoin, of } from 'rxjs';

import {Address, Batch_Record, Currency, Currency_Rate, Item, Price, Price_Type, Quote_Item, Store, User} from '../../models/RestModels';
import {ItemInfo, ItemOptionValueInfo, OrderItemInfo, QuoteInfo, QuoteItemInfo} from 'src/app/models/models';
import {mergeMap} from 'rxjs/operators';
import {SearchObject} from 'src/app/services/Rest';
import { GetEmpty } from 'src/app/classes/Empties';


import { ErrorMessage, Utils } from 'src/app/classes/Utils';


@Component({
	selector: 'app-save-quote',
	templateUrl: './save-quote.component.html',
	styleUrls: ['./save-quote.component.css']
})
export class SaveQuoteComponent extends BaseComponent implements OnInit {

	quote_info:QuoteInfo = GetEmpty.quoteInfo(this.rest);
	store_list:Store[] = [];
	input_search:string = '';
	item_info_list:ItemInfo[] = [];
	show_add_new: boolean;
	total:number = 0;
	subtotal:number = 0;
	total_tax:number = 0;
	store_id:number | null;
	search_client_str:string = '';
	client_list:User[] = [];
	user_client: User | null = null;
	show_client_list:boolean = false;
	client_search_index: number;
	address_list: Address[];
	currency_rate_list: Currency_Rate[] = [];
	price_type_list: Price_Type[] = [];
	currency_list: Currency [] = [];
	search_str:string = '';
	selected_item_info: ItemInfo | null = null;
	show_select_options: boolean = false;
	editing_quote_item_info: QuoteItemInfo | null = null;
	selected_option_quantities: Record<number, number> = {};

	// View batches
	show_view_batches: boolean = false;
	view_batches_loading: boolean = false;
	view_batches_list: Batch_Record[] = [];
	selected_quote_item_info: QuoteItemInfo | null = null;


	ngOnInit()
	{
		this.quote_info = GetEmpty.quoteInfo(this.rest);

		this.route.paramMap.pipe
		(
			mergeMap((param_map)=>
			{
				this.is_loading = true;
				let title = 'Agregar Nueva cotización';
				if( param_map.has('id') )
				{
					title = 'Editar cotización #'+param_map.get('id');
				}
				this.setTitle( title );

				let obs = param_map.has('id')
					? this.rest.quote_info.get( param_map.get('id') )
					: of( GetEmpty.quoteInfo(this.rest) )

				return forkJoin
				({
					quote_info: obs,
					stores: this.rest.store.search({limit:9999999}),
					currency_rates: this.rest.getCurrencyRates(),
					price_type: this.rest.getPriceTypes(),
					currency: this.rest.currency.search({limit:9999999})
				});
			})
		)
		.subscribe((response)=>
		{
			this.store_list = response.stores.data;
			this.quote_info = response.quote_info;
			this.search_client_str = this.quote_info.quote.name;
			this.price_type_list = response.price_type.data;

			if (!this.quote_info.quote.price_type_id)
			{
				this.quote_info.quote.price_type_id = this.price_type_list[0].id;
			}

			this.is_loading = false;
			this.quote_info.items.forEach((i)=>
			{
				if( i.quote_item.price_multiplier === undefined || i.quote_item.price_multiplier === null )
				{
					i.quote_item.price_multiplier = 1;
				}
				this.rest.updateOrderItemPrice(i.quote_item, this.getEffectiveTaxPercent(i.item), 0);
			});
			this.calculateTotal();
			this.currency_rate_list = response.currency_rates.data;
			this.currency_list = response.currency.data;

			if( !this.quote_info.quote.store_id )
			{
				if( this.rest.current_user.store_id )
				{
					this.onSucursalChange(this.rest.current_user.store_id );
				}
				else
				{
					this.onSucursalChange( this.store_list[0].id );
				}
			}
			else
			{
				this.store_id = this.quote_info.quote.store_id;
				this.onSucursalChange( this.store_id );
			}


		},(error)=>this.showError(error));
	}

	noRegistrarUsuario()
	{
		this.client_search_index	= 0;
		this.show_client_list	= false;
		this.user_client		= null;
		this.quote_info.client_user = null;
		this.quote_info.quote.name = this.search_client_str;
		this.quote_info.quote.client_user_id = null;
		this.quote_info.client_user = null;
		this.client_list = [];
	}

	onSelectClient(client_user:User )
	{
		this.client_search_index = 0;
		this.user_client = client_user;
		this.search_client_str = client_user.name;
		this.quote_info.quote.name = client_user.name;
		this.quote_info.quote.client_user_id = client_user.id;
		this.quote_info.quote.phone = client_user.phone;
		this.quote_info.quote.price_type_id = client_user.price_type_id;
		this.quote_info.quote.email = client_user.email || '';
		this.show_client_list = false;
		//this.order_info.order.price_type_id = client_user.price_type_id;
		this.client_list = [];
		this.quote_info.client_user = client_user;

		let search:SearchObject<Address> = this.getEmptySearch();
		search.limit = 99999;
		search.eq.user_id = this.user_client.id;
		search.sort_order = ['address_ASC'];

		//this.subs.sink = this.rest.address
		//.search(search)
		//.subscribe((response)=>
		//{
		//	this.address_list = response.data;

		//	if( response.data.length )
		//		this.quote_info.order.shipping_address_id = this.address_list[0].id;
		//});
	}

	onClientSearch(evt:any)
	{
		let html_input:HTMLInputElement = evt.target as HTMLInputElement;
		this.user_client = null;
		let search_term:string = html_input.value.trim();
		this.quote_info.quote.name = search_term;
		if( !search_term )
		{
			this.client_list = [];
			return;
		}

		let search:SearchObject<User> = this.getEmptySearch();
		search.limit = 20;
		search.eq.type = 'CLIENT';
		search.lk.name = search_term;
		search.lk.phone = search_term;

		this.subs.sink = this.rest.user
		.search(search)
		.subscribe((response)=>
		{
			this.show_client_list = true;
			this.client_list= response.data;
		},(error)=>{
			console.log(error);
		});
	}

	save( $event )
	{

		if( this.is_loading )
			return

		this.calculateTotal();

		//La cabecera se puebla con las sumas de los valores que puso
		//rest.service en cada renglon (unitario, subtotal, iva, total tal cual),
		//para que la orden creada despues herede los mismos valores.
		this.quote_info.quote.subtotal = this.subtotal;
		this.quote_info.quote.tax = this.total_tax;
		this.quote_info.quote.total = this.total;

		this.is_loading = true;


		if( this.quote_info?.quote?.id	)
		{
			this.subs.sink	= this.rest.quote_info.update( this.quote_info )
			.subscribe((quote)=>
			{
				this.is_loading = false;
				this.showSuccess('La cotización se actualizo exitosamente');
				this.router.navigate(['/view-quote',this.quote_info.quote.id],{replaceUrl:true});
			},(error)=>this.showError(error));
		}
		else
		{
			this.subs.sink	= this.rest.quote_info.create( this.quote_info )
			.subscribe((quote)=>
			{
				this.is_loading = false;
				this.showSuccess('La cotización se guardo exitosamente');
				this.router.navigate(['/view-quote',quote.quote.id],{replaceUrl:true});
			},(error)=>this.showError(error));
		}
	}

	onInput(evt:Event)
	{
		if( evt.target['value'] == '' )
		{
			this.item_info_list = [];
			return;
		}

		let input = evt.target as HTMLInputElement;
		this.subs.sink = this.rest.item_info.search({
			eq:{status:'ACTIVE'},
			search_extra:{category_name:input.value}
		})
		.subscribe((response)=>
		{
			for(let ii of response.data)
			{
				ii.stock_record = ii.records.find((sr)=>sr.store_id == this.store_id);
			}

			this.item_info_list = response.data;
		});
	}

	onItemInfoSelect(item_info:ItemInfo)
	{
		if( item_info.options.length > 0 )
		{
			if( !this.rest.local_preferences.quote_options_enabled )
			{
				this.showError('No se pueden seleccionar artículos con opciones');
				return;
			}
			this.selected_item_info = item_info;
			this.editing_quote_item_info = null;
			this.selected_option_quantities = {};
			this.show_select_options = true;
			return;
		}

		this.show_add_new = false;

		let index = this.quote_info.items.findIndex(i=>{ return i.item.id == item_info.item.id && i.quote_item.status == 'ACTIVE' });

		if( index !== -1 )
		{
			this.showError('El artículo ya se encuentra en la lista');
			return;
		}

		this.item_info_list = [];

		let price:Price | null = item_info.prices.find(p=>
		{
			let same_list = p.price_list_id == this.quote_info.store.price_list_id;

			if( this.quote_info.quote.price_type_id )
			{
				return same_list && p.price_type_id == this.quote_info.quote.price_type_id && this.quote_info.quote.currency_id == p.currency_id;
			}

			return same_list
		}) || null;


		let default_price:Price | null = item_info.prices.find(p=>
		{
			let same_list = p.price_list_id == this.quote_info.store.price_list_id;

			if( this.quote_info.quote.price_type_id )
			{
				return same_list && p.price_type_id == this.quote_info.quote.price_type_id && this.quote_info.store.default_currency_id == p.currency_id
			}

			return same_list
		}) || null;


		if( price == null )
			price = default_price;

		let same_list_price:Price | null = item_info.prices.find(p=>
		{
			let same_list = p.price_list_id == this.quote_info.store.price_list_id;
			let same_price_type = p.price_type_id == this.quote_info.quote.price_type_id;

			if( this.quote_info.quote.price_type_id )
			{
				return same_list && same_price_type;
			}
			return same_list
		}) || null;

		if( price == null )
			price = same_list_price;


		let quote_item:Quote_Item= {
			ieps_calculated: 0,
			ieps_value: 0,
			ieps_type: 'RATE',
			quote_id: this.quote_info.quote.id || 0,
			item_id: item_info.item.id,
			item_option_id: null,
			item_option_qty: 0,
			item_group: 0,
			margin_gain: 0.0,
			price_multiplier: 1.0,
			discount: 0,
			provider_price: 0,
			subtotal: 0,
			total: 0,
			qty: 1,
			tax: 0,
			status: 'ACTIVE',
			unitary_price_meta: price?.price ||item_info.item.reference_price || 0,
			original_unitary_price: price?.price || item_info.item.reference_price || null,
			unitary_price: price?.price || item_info.item.reference_price || null,
			tax_included: price?.tax_included || 'NO',
		};

		let store:Store | null = this.store_list.find(s=>s.id == this.store_id ) || null;

		let price_type = this.price_type_list.find(price_type=>price_type.id == this.quote_info.quote.price_type_id);

		if( price && store )
		{
			//XXX posible error no esta tomando en cuenta si no pertenece al mismo tipo de moneda

			this.rest.setQuoteItemPrice
			(
				quote_item,
				price,
				this.quote_info.store.default_currency_id,
				this.quote_info.quote.currency_id ,
				this.currency_rate_list,
				price_type,
				item_info.item
			);
		}

		let quote_item_info:QuoteItemInfo = {
			quote_item: quote_item,
			item: item_info.item,
			category: item_info.category
		};

		this.quote_info.items.push( quote_item_info );

		let tax_percent = this.getEffectiveTaxPercent(quote_item_info.item);

		this.rest.updateOrderItemPrice(quote_item_info.quote_item, tax_percent, 0);


		this.input_search = '';
		this.calculateTotal();
	}

	onTaxIncludedChange(quote_item:QuoteItemInfo,value:'YES'|'NO')
	{
		quote_item.quote_item.tax_included = value;

		let tax_percent = this.getEffectiveTaxPercent(quote_item.item);

		this.rest.updateOrderItemPrice(quote_item.quote_item, tax_percent, 0);


		this.calculateTotal();
	}
	onQtyChange(quote_item:QuoteItemInfo, value:number)
	{
		quote_item.quote_item.qty = value;
		let tax_percent = this.getEffectiveTaxPercent(quote_item.item);

		this.rest.updateOrderItemPrice(quote_item.quote_item, tax_percent, 0);

		this.calculateTotal();
	}
	onPriceChange(quote_item:QuoteItemInfo, value:number)
	{
		quote_item.quote_item.original_unitary_price = value;

		let tax_percent = this.getEffectiveTaxPercent(quote_item.item);

		this.rest.updateOrderItemPrice(quote_item.quote_item, tax_percent, 0);

		this.calculateTotal();
	}

	onMultiplierChange(quote_item:QuoteItemInfo, multiplier:number)
	{
		let items_to_update = [quote_item];

		if( quote_item.quote_item.item_group )
		{
			items_to_update = this.quote_info.items.filter(i => i.quote_item.item_group == quote_item.quote_item.item_group);
		}

		items_to_update.forEach((qii)=>
		{
			qii.quote_item.price_multiplier = multiplier;
			qii.quote_item.original_unitary_price = qii.quote_item.price_multiplier * qii.quote_item.unitary_price_meta;

			let tax_percent = this.getEffectiveTaxPercent(qii.item);

			this.rest.updateOrderItemPrice(qii.quote_item, tax_percent, 0);
		});

		this.calculateTotal();
	}

	// Los artículos EXENTOS y los que tienen un IVA ajustado (applicable_tax == 'PERCENT',
	// que incluye el ajuste IVA 0%, 8% y 16%) no se ven afectados por el IVA definido en la
	// cotización: usan su propio impuesto. Solo los artículos DEFAULT toman el IVA de la cotización.
	getEffectiveTaxPercent(item:Item):number
	{
		if( item.applicable_tax == 'EXEMPT' )
			return 0;

		if( item.applicable_tax == 'PERCENT' )
			return item.tax_percent;

		return this.quote_info.quote.tax_percent;
	}

	calculateTotal()
	{
		let total = 0;
		let subtotal = 0;
		let total_tax = 0;
		this.quote_info.items.forEach((i)=>
		{
			if( i.quote_item.status == 'ACTIVE' )
			{
				total += i.quote_item.total;
				subtotal += i.quote_item.subtotal;
				total_tax += i.quote_item.tax;
			}
		});
		this.total = Math.round( total*100 )/100;
		this.subtotal = Math.round( subtotal*100 )/100;
		this.total_tax = Math.round( total_tax*100 )/100;
	}

	onSucursalChange(store_id:number)
	{
		let store:Store = this.store_list.find(s=>s.id == store_id) || null;

		if( !store )
		{
			this.quote_info.quote.store_id = null;
		}
		else
		{
			this.quote_info.quote.tax_percent = store.tax_percent;
			this.quote_info.quote.store_id = store_id;
			this.quote_info.store = store;
			this.quote_info.items.forEach((quote_item_info)=>
			{
				let tax_percent = this.getEffectiveTaxPercent(quote_item_info.item);

				this.rest.updateOrderItemPrice(quote_item_info.quote_item, tax_percent, 0);
			});

			this.calculateTotal();
		}

		this.store_id = store?.id || null;
	}
	onTaxPercentChange(quote_tax_percent:number)
	{
		this.quote_info.quote.tax_percent = quote_tax_percent;
		this.quote_info.items.forEach((quote_item_info)=>
		{
			let tax_percent = this.getEffectiveTaxPercent(quote_item_info.item);

			this.rest.updateOrderItemPrice(quote_item_info.quote_item, tax_percent, 0);

		})
		this.calculateTotal();
	}

	removeItem(item:QuoteItemInfo)
	{
		// If the item has an item_group, remove all items in the same group
		if( item.quote_item.item_group )
		{
			// First mark persisted items as deleted, then remove non-persisted items in reverse order
			for( let i = this.quote_info.items.length - 1; i >= 0; i-- )
			{
				let group_item = this.quote_info.items[i];
				if( group_item.quote_item.item_group == item.quote_item.item_group )
				{
					if( group_item.quote_item.id )
					{
						group_item.quote_item.status = 'DELETED';
					}
					else
					{
						this.quote_info.items.splice(i, 1);
					}
				}
			}
		}
		else
		{
			if( item.quote_item.id )
			{
				item.quote_item.status = 'DELETED';
			}
			else
			{
				let index = this.quote_info.items.findIndex(i => i === item);
				if( index > -1 )
				{
					this.quote_info.items.splice(index, 1);
				}
			}
		}
		this.calculateTotal();
	}

	onOrderItemWithOptions(order_item_info_list: OrderItemInfo[])
	{
		if( order_item_info_list.length == 0 )
		{
			this.show_select_options = false;
			this.selected_item_info = null;
			this.editing_quote_item_info = null;
			this.selected_option_quantities = {};
			return;
		}

		let price_type = this.price_type_list.find(pt => pt.id == this.quote_info.quote.price_type_id);
		let item_group = this.editing_quote_item_info?.quote_item.item_group || Date.now();

		if( this.editing_quote_item_info )
		{
			this.removeItem(this.editing_quote_item_info);
		}

		for( let order_item_info of order_item_info_list )
		{
			let editing_parent_info = this.editing_quote_item_info;
			let editing_parent_quote_item = editing_parent_info?.quote_item || null;
			let is_editing_parent = !!editing_parent_info
				&& !!editing_parent_quote_item
				&& !order_item_info.order_item.item_option_id
				&& order_item_info.item.id == editing_parent_info.item.id;

			let price: Price | null = order_item_info.prices.find(p =>
			{
				let same_list = p.price_list_id == this.quote_info.store.price_list_id;

				if( this.quote_info.quote.price_type_id )
				{
					return same_list && p.price_type_id == this.quote_info.quote.price_type_id && this.quote_info.quote.currency_id == p.currency_id;
				}

				return same_list;
			}) || null;

			let default_price: Price | null = order_item_info.prices.find(p =>
			{
				let same_list = p.price_list_id == this.quote_info.store.price_list_id;

				if( this.quote_info.quote.price_type_id )
				{
					return same_list && p.price_type_id == this.quote_info.quote.price_type_id && this.quote_info.store.default_currency_id == p.currency_id;
				}

				return same_list;
			}) || null;

			if( price == null )
				price = default_price;

			let unitary_price = order_item_info.order_item.original_unitary_price ?? price?.price ?? order_item_info.item.reference_price ?? 0;

			let quote_item: Quote_Item = {
				ieps_calculated: 0,
				ieps_value: 0,
				ieps_type: 'RATE',
				quote_id: this.quote_info.quote.id || 0,
				item_id: order_item_info.item.id,
				item_option_id: order_item_info.order_item.item_option_id,
				item_option_qty: order_item_info.order_item.item_option_qty || 0,
				item_group: item_group,
				margin_gain: 0.0,
				price_multiplier: 1.0,
				discount: 0,
				provider_price: 0,
				subtotal: 0,
				total: 0,
				qty: order_item_info.order_item.qty,
				tax: 0,
				status: 'ACTIVE',
				unitary_price_meta: unitary_price,
				original_unitary_price: unitary_price,
				unitary_price: unitary_price,
				tax_included: price?.tax_included || 'NO',
			};

			if( is_editing_parent )
			{
				quote_item.price_multiplier = editing_parent_quote_item.price_multiplier;
				quote_item.discount = editing_parent_quote_item.discount;
				quote_item.discount_percent = editing_parent_quote_item.discount_percent;
				quote_item.provider_price = editing_parent_quote_item.provider_price;
				quote_item.margin_gain = editing_parent_quote_item.margin_gain;
				quote_item.qty = editing_parent_quote_item.qty;
				quote_item.unitary_price_meta = editing_parent_quote_item.unitary_price_meta;
				quote_item.original_unitary_price = editing_parent_quote_item.original_unitary_price;
				quote_item.unitary_price = editing_parent_quote_item.unitary_price;
				quote_item.tax_included = editing_parent_quote_item.tax_included;
				quote_item.note = editing_parent_quote_item.note;
			}

			if( price && price_type && !is_editing_parent )
			{
				this.rest.setQuoteItemPrice(
					quote_item,
					price,
					this.quote_info.store.default_currency_id,
					this.quote_info.quote.currency_id,
					this.currency_rate_list,
					price_type,
					order_item_info.item
				);
			}

			let quote_item_info: QuoteItemInfo = {
				quote_item: quote_item,
				item: order_item_info.item,
				category: order_item_info.category
			};

			this.quote_info.items.push(quote_item_info);

			let tax_percent = this.getEffectiveTaxPercent(quote_item_info.item);

			this.rest.updateOrderItemPrice(quote_item_info.quote_item, tax_percent, 0);
		}

		this.show_select_options = false;
		this.selected_item_info = null;
		this.editing_quote_item_info = null;
		this.selected_option_quantities = {};
		this.input_search = '';
		this.calculateTotal();
	}

	editOptions(qii: QuoteItemInfo)
	{
		if( !qii.quote_item.item_group )
		{
			this.showError('Este artículo no tiene opciones para editar');
			return;
		}

		if( !this.rest.local_preferences.quote_options_enabled )
		{
			this.showError('No se pueden editar artículos con opciones');
			return;
		}

		this.is_loading = true;
		this.subs.sink = this.rest.item_info.get(qii.item.id)
		.subscribe((item_info)=>
		{
			this.is_loading = false;
			this.editing_quote_item_info = qii;
			this.selected_item_info = item_info;
			this.selected_option_quantities = this.getSelectedOptionQuantities(qii, item_info);
			this.show_select_options = true;
		},(error)=>
		{
			this.is_loading = false;
			this.showError(error);
		});
	}

	getSelectedOptionQuantities(qii: QuoteItemInfo, item_info: ItemInfo): Record<number, number>
	{
		let quantities: Record<number, number> = {};
		let item_group = qii.quote_item.item_group;

		if( !item_group )
			return quantities;

		this.quote_info.items
		.filter((item)=>item.quote_item.status == 'ACTIVE' && item.quote_item.item_group == item_group && !!item.quote_item.item_option_id)
		.forEach((item)=>
		{
			let option_value: ItemOptionValueInfo | null = null;

			item_info.options.some((option)=>
			{
				option_value = option.values.find((value)=>
				{
					return value.item.id == item.item.id
						&& value.item_option_value.item_option_id == item.quote_item.item_option_id;
				}) || null;

				return !!option_value;
			});

			if( option_value )
			{
				quantities[option_value.item_option_value.id] = item.quote_item.item_option_qty || item.quote_item.qty || 0;
			}
		});

		return quantities;
	}

	viewBatches(qii: QuoteItemInfo)
	{
		this.selected_quote_item_info = qii;
		this.show_view_batches = true;
		this.view_batches_loading = true;
		this.view_batches_list = [];

		this.subs.sink = this.rest.batch_record.search({
			eq: {
				item_id: qii.item.id,
				store_id: this.quote_info.quote.store_id,
				is_current: 1
			},
			gt: { qty: 0 },
			limit: 1000
		}).subscribe(
			(response) => {
				this.view_batches_list = response.data;
				this.view_batches_loading = false;
			},
			(error) => {
				this.view_batches_loading = false;
				this.showError('Error al cargar lotes');
			}
		);
	}

	selectBatch(batch: Batch_Record)
	{
		if (!this.selected_quote_item_info)
			return;

		let qty_to_note = Math.min(this.selected_quote_item_info.quote_item.qty, batch.qty);
		let note = `Lote: ${batch.batch || 'N/A'}`;
		if (batch.expiration_date)
		{
			note += ` Vence: ${Utils.getDateString(batch.expiration_date, false)}`;
		}
		note += ` Cant: ${qty_to_note}`;

		if (this.selected_quote_item_info.quote_item.note)
		{
			this.selected_quote_item_info.quote_item.note += ', ' + note;
		}
		else
		{
			this.selected_quote_item_info.quote_item.note = note;
		}

		this.show_view_batches = false;
	}
}
